import StoreVisitsContainer from "./container";
export { StoreVisitsContainer };



// WEBPACK FOOTER //
// ./client/modules/StoreVisits/components/StoreVisitsContainer/index.ts